import { CPTSlab, CPTSlabToLabel } from "./cptSlabUtils";

export type CPTHoursOffsetBySlab = Record<string, number | null>;

export function parseCptHoursOffset(raw: unknown): CPTHoursOffsetBySlab {
  if (!raw) return { HLD: 4 };

  if (typeof raw === "object" && raw !== null) {
    const obj = raw as Record<string, unknown>;
    return {
      HLD: (obj.HLD ?? obj.hld ?? 4) as number,
      LOCAL: (obj.LOCAL ?? obj.local ?? null) as number | null,
      OUTSIDE: (obj.OUTSIDE ?? obj.outside ?? null) as number | null,
    };
  }

  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw) as Record<string, unknown>;
      return {
        HLD: (parsed.HLD ?? parsed.hld ?? 4) as number,
        LOCAL: (parsed.LOCAL ?? parsed.local ?? null) as number | null,
        OUTSIDE: (parsed.OUTSIDE ?? parsed.outside ?? null) as number | null,
      };
    } catch {
      return { HLD: 4 };
    }
  }

  return { HLD: 4 };
}

export function calculateCPTForSlab(
  orderEffectiveAt: string | Date | undefined,
  slab: CPTSlab,
  cptHoursOffsetBySlab: CPTHoursOffsetBySlab
): Date | null {
  if (!orderEffectiveAt) return null;

  const orderEffectiveAtTimestamp = new Date(orderEffectiveAt);
  if (isNaN(orderEffectiveAtTimestamp.getTime())) return null;

  const slabKey = CPTSlabToLabel[slab];
  const hoursOffset = cptHoursOffsetBySlab[slabKey];

  if (hoursOffset === null || hoursOffset === undefined) {
    return null;
  }

  const cpt = new Date(orderEffectiveAtTimestamp);
  cpt.setHours(cpt.getHours() + Number(hoursOffset));
  return cpt;
}
